import './Nav.css'
import { NavLink, Link } from 'react-router-dom';
import { useState } from 'react';

const Nav = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    
    const getClass = ({ isActive }) => (isActive ? 'active' : undefined)
    
    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    }
    
    const closeMenu = () => {
        setIsMenuOpen(false);
    }

    return (
        <nav className="nav">
            <Link to="/" className="nav-logo-link">
                <img src={require('../assets/renz-simple_transparent.png')} alt="Renz Foods Logo" className='nav-logo' />
            </Link>
            
            {/* Hamburger Menu Button */}
            <button 
                className={`nav-hamburger ${isMenuOpen ? 'open' : ''}`}
                onClick={toggleMenu}
                aria-label="Toggle navigation menu"
            >
                <span></span>
                <span></span>
                <span></span>
            </button>
            
            {/* Navigation Menu */}
            <ul className={`nav-menu ${isMenuOpen ? 'open' : ''}`}>
                <li><NavLink to='/menu' className={getClass} onClick={closeMenu}>Menu</NavLink></li>
                <li><NavLink to='/find-us' className={getClass} onClick={closeMenu}>Find Us</NavLink></li>
                <li><NavLink to='/rewards' className={getClass} onClick={closeMenu}>Rewards</NavLink></li>
                <li><NavLink to='/order-now' className={getClass} onClick={closeMenu}>ORDER NOW</NavLink></li>
            </ul>
        </nav>
    )
}

export default Nav;